export default __webpack_public_path__ + "static/media/video_size.343ed004.svg";